import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import store from "../../../../redux/store";
import {
    serviceActionListFilter,
    serviceActionError
} from "./action/ActionListServiceHistorySatiaScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";
//import ParentScreen from "../../../../ParentScreen";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMButton from "../../../../customviews/HMButton";
import HMIcon from "../../../../customviews/HMIcon";
import * as NavigationService from "../../../../redux/NavigationService";
import {Tools} from "../../../../tools/Tools";

let container = null;
export default class ListServiceHistorySatiaScreen extends Component {
    constructor(props) {
        super(props);
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;
        let lat = 0
        let long = 0
        if (!myLocation) {
            lat = parseFloat(myLocation ? myLocation.coords.latitude : 0);
            long = parseFloat(myLocation ? myLocation.coords.longitude : 0);
            // long = parseFloat(props.navigation && props.route.params ? props.route.params.position.coords.longitude : props.position ? props.position.coords.longitude : 0);

        }
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 800 ? 2 : 1;

        }

        this.state = {


            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,

            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,

            lat: lat,
            long: long,
            dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                name: 'در دست اقدام',
                id: 2
            }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                name: 'تایید واحد',
                id: 5
            },],
            textCondition: null,
            arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                name: 'تکراری در دست اقدام',
                id: 3
            }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],
            Condition: {id: 0, value: "وضعیت پیام"},

            arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null

        };
        container = this;

        store.dispatch(serviceActionListFilter([]))
        this.props.callserviceActionRefresh();
        this.getData(1)
        // this.props.navigation.addListener('focus', () => {
        //      /*   store.dispatch(serviceActionListFilter([]))
        //         props.callserviceActionRefresh();
        //         this.getData(1)*/
        //     }
        // )
        // )

    }

    state = {
        show: false
    };

    componentWillReceiveProps(propss) {


    }

    async componentDidMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 800 ? 2 : 1,
                    },
                )


            })
    }

    componentWillUnmount() {

    }

    async getData(page) {
        //  let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlListServiceHistorySatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListServiceHistorySatiaScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListServiceHistorySatiaScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListServiceHistorySatiaScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListServiceHistorySatiaScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Fire,

            "mode": typeExport._GetDashboard,
            "lang": i18n.locale,
            "token": store.getState().reducerSplashSatiaScreen.token,
            "page": page,

        };
        if (store.getState().reducerSplashSatiaScreen.Connection) {

            this.props.callService(typeExport._baseUrlSatia, paramss, typeExport.TypeGetListServiceHistorySatiaScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatia + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatiaFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    _onMapReady = () => this.setState({marginBottom: 0})

    render() {
        // let {item} = this.props.item ? this.props : this.props.route.params;
        let item = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.item : this.props.item;

        let myLocation = store.getState().reducerSplashSatiaScreen.Location;

        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        //let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];

        let check_ui = Platform.OS === "web" && this.state.viewportWidth > 600
        return (
            <View style={{position: 'relative', flex: 1,}}>


                {/*        <HMImageBackground

                />*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>

                        {
                            this.props.item ?
                                null
                                :
                                <HMActionBarSatia
                                    //exit={true}
                                    menu
                                    back

                                    props={this.props} statusBarTransparent
                                    // text={i18n.t('ListServiceHistorySatia.title')}
                                    text={(item && item.name ? item.name : (item && item.title ? item.title : 'سوابق سرویس ها'))}
                                    //text={(data.name ? data.name : (data.title ? data.title : ''))}
                                    //  text={this.state.arraySelected.length}


                                    //  text={i18n.t('constant.Information')}

                                    headerVisibility more_menu
                                    onBackPress={() => this.props.navigation.pop()}

                                />
                        }
                        {/*<TouchableOpacity
                            onPress={()=>{
                                store.dispatch(serviceActionAddSubList([{
                                    address:"aaaa",
                                    code: "_",
                                    color: "#ff0000",
                                    comment: [],
                                    createdtime: "19/8/8",
                                    image:null,
                                    video: null,
                                    latitude: '43.56564',
                                    longitude: "34.37546",
                                    status: i18n.t('constant.registrated'),
                                    title: "aaabbbb",
                                    subjectid: "111"
                                }, ...store.getState().reducerListServiceHistorySatiaScreen.results]))
                            }}
                            style={{width:'100%',height:moderateScale(40)}}
                        />*/}
                        <View style={{flex: 1}}>
                            {/*      <View
                                style={{
                                    height: moderateScale(42),
                                    backgroundColor: Colors.colorPrimary,
                                    flexDirection: 'row',
                                    marginHorizontal: moderateScale(10),
                                    marginTop: moderateScale(6),
                                    borderRadius: moderateScale(14),
                                    borderColor: Colors.colorDark,
                                    borderWidth: moderateScale(1),
                                    //  marginBottom: moderateScale(10)
                                    // width:'100%'
                                }}>

                                <View
                                    style={{
                                        flex: .8,
                                        height: moderateScale(40),
                                        backgroundColor: Colors.white,
                                        borderRadius: moderateScale(14),
                                        flexDirection: 'row',
                                        paddingHorizontal: moderateScale(4),
                                        alignItems: 'center',

                                    }}>

                                    <View style={{width: moderateScale(5)}}/>

                                    <View style={{flex: 1, marginHorizontal: moderateScale(8)}}>
                                        <HMTextInput value={this.state.trackingCode}
                                                     onChangeText={(text) => this.setState({trackingCode: text}, () => {
                                                         //  this.getJsonMap()

                                                     })}
                                                     _height={40}
                                            //  autoFocus
                                            //  placeholder={i18n.t('constant.filter')}
                                                     placeholder={i18n.t('constant.TrackingCode')}
                                                     NoShowPlaceholder
                                            //باتد_width={'80%'}
                                            // icon={"md-person"}
                                                     style={{
                                                         fontSize: moderateScale(11),

                                                         // marginTop: moderateScale(6)
                                                     }} underlineColorAndroid="transparent"/>
                                    </View>
                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        this.getData(1)
                                        //  this.nextScreen(item, type)
                                    }}
                                    style={{
                                        flex: .2,
                                        height: moderateScale(32),
                                        backgroundColor: Colors.colorPrimary,
                                        borderTopEndRadius: moderateScale(14),
                                        borderBottomEndRadius: moderateScale(14),
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>

                                    <HMTextView
                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                        text={i18n.t('constant.Search')}
                                        type={"bold"}
                                        style={{
                                            textAlign: "center",
                                            color: Colors.white,
                                            fontSize: moderateScale(11)

                                        }}/>
                                </TouchableOpacity>

                            </View>*/}


                            {
                                check_ui ?
                                    <View
                                        style={{
                                            width: '100%',
                                            flexDirection: 'row',
                                            backgroundColor: Colors.colorRow,
                                            marginTop: moderateScale(2)

                                            // alignSelf: 'center'
                                            // marginVertical:moderateScale(6),
                                        }}>
                                        <View
                                            style={{
                                                flex: .17,
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginVertical: moderateScale(2)
                                            }}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"تاریخ"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.white
                                                    //  marginTop: moderateScale(4),
                                                    //  textAlign: "right",
                                                }}/>
                                        </View>
                                        <View style={{
                                            height: '100%',
                                            width: moderateScale(1),
                                            alignSelf: 'center',
                                            backgroundColor: Colors.light43
                                        }}/>

                                        <View
                                            style={{flex: .28, alignItems: 'center', justifyContent: 'center'}}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"سرویس"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.white,
                                                    //  marginTop: moderateScale(4),
                                                    textAlign: "center",

                                                }}/>
                                        </View>
                                        <View
                                            style={{
                                                height: '100%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43
                                            }}/>
                                        <View
                                            style={{flex: .16, alignItems: 'center', justifyContent: 'center'}}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"نوع خرید"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.white,
                                                    //  marginTop: moderateScale(4),
                                                    textAlign: "center",

                                                }}/>
                                        </View>
                                        <View
                                            style={{
                                                height: '100%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43
                                            }}/>
                                        <View
                                            style={{flex: .26, alignItems: 'center', justifyContent: 'center'}}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"توضیحات"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.white,
                                                    //  marginTop: moderateScale(4),
                                                    textAlign: "center",
                                                }}/>
                                        </View>
                                        <View
                                            style={{
                                                height: '100%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43
                                            }}/>
                                        <View
                                            style={{flex: .08, alignItems: 'center', justifyContent: 'center'}}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"وضعیت"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.white,
                                                    //  marginTop: moderateScale(4),
                                                    textAlign: "center",
                                                }}/>
                                        </View>
                                        <View
                                            style={{
                                                height: '100%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43
                                            }}/>
                                        <View
                                            style={{flex: .05, alignItems: 'center', justifyContent: 'center'}}>
                                            <HMTextView
                                                // numberOfLines={2}
                                                type={"bold"}
                                                text={"عملیات"}
                                                style={{
                                                    fontSize: moderateScale(14),

                                                    color: Colors.white,
                                                    //  marginTop: moderateScale(4),
                                                    textAlign: "center",
                                                }}/>
                                        </View>


                                    </View>
                                    :
                                    null

                            }

                            <View style={{
                                width: '99%',
                                height: moderateScale(1),
                                alignSelf: 'center',
                                backgroundColor: Colors.light43,
                            }}/>
                            <EmptyView empty={this.props.empty}/>
                            <FlatList
                                data={this.props.results}
                                //data={[]}
                                //   data={[{id:1,title:"بهره برداری",type:"",description:'برای استفاده آماده است',date:'21:09 1398/12/18'},{id:2,title:"آماده به نصب",type:"",description:'',date:'10:33 1398/09/07'},{id:1,title:"ارسال به مرکز",type:"",description:'',date:'10:33 1398/09/01'},{id:1,title:"بدون وضعیت",type:"",description:'',date:'10:33 1398/08/07'},]}

                                //  renderItem={this.renderItem}
                                renderItem={({item, index}) => {


                                    return <View
                                        style={{
                                            flex: 1,

                                        }}>
                                        {
                                            check_ui ?

                                                <View
                                                    style={{
                                                        flex: 1,
                                                        overflow: 'hidden',
                                                        //height:  moderateScale(100),
                                                        // padding: moderateScale(4),
                                                        //  margin:moderateScale(5),
                                                        borderWidth: moderateScale(1),
                                                        borderRadius: moderateScale(2),
                                                        borderColor: '#ddd',
                                                        borderBottomWidth: 0,
                                                        shadowColor: '#000',
                                                        shadowOffset: {width: 0, height: moderateScale(.7)},
                                                        shadowOpacity: 0.6,
                                                        shadowRadius: moderateScale(2),
                                                        elevation: moderateScale(1),
                                                        // marginLeft: moderateScale(1),
                                                        // marginRight: moderateScale(1),
                                                        // marginTop: moderateScale(1),
                                                        // marginBottom: moderateScale(1),
                                                        //backgroundColor: Colors.white,
                                                    }}>
                                                    <View
                                                        style={{
                                                            width: '100%',
                                                            flexDirection: 'row',
                                                            backgroundColor: Colors.white,
                                                            // alignSelf: 'center'
                                                            // marginVertical:moderateScale(6),
                                                        }}>
                                                        <View
                                                            style={{
                                                                flex: .17,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginVertical: moderateScale(2)
                                                            }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.Date}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.blackLight,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "right",
                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.light43
                                                        }}/>

                                                        <View
                                                            style={{
                                                                flex: .28,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.Name}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.blackLight,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",

                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.light43
                                                        }}/>
                                                        <View
                                                            style={{
                                                                flex: .16,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.Type}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.blackLight,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",

                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.light43
                                                        }}/>
                                                        <View
                                                            style={{
                                                                flex: .26,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.Comment}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.blackLight,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.light43
                                                        }}/>
                                                        <View
                                                            style={{
                                                                flex: .08,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                // backgroundColor:"#9a2eee"
                                                            }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.ActiveName}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.blackLight,
                                                                    //  marginTop: moderateScale(4),
                                                                    // textAlign: "center",
                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.light43
                                                        }}/>
                                                        <TouchableOpacity
                                                            disabled={!item.ActivePrint}
                                                            onPress={() => {
                                                                NavigationService.navigateParams("FactorServiceHistorySatiaScreen", {item: item})
                                                            }}
                                                            style={{
                                                                flex: .05,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                // backgroundColor:"#9a2eee"
                                                            }}>
                                                            <HMIcon
                                                                //   type={"FontAwesome"}
                                                                // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                name={"print-outline"}
                                                                //resizeMode="stretch"
                                                                style={[{fontSize: moderateScale(20)}, {
                                                                    color: item.ActivePrint ? Colors.green : Colors.gray
                                                                }]}/>

                                                        </TouchableOpacity>

                                                    </View>
                                                </View>

                                                :
                                                <View
                                                    style={{
                                                        flex: 1,
                                                        overflow: 'hidden',
                                                        //height:  moderateScale(100),
                                                        // padding: moderateScale(4),
                                                        margin: moderateScale(5),
                                                        borderWidth: moderateScale(1),
                                                        borderRadius: moderateScale(2),
                                                        borderColor: '#ddd',
                                                        borderBottomWidth: 0,
                                                        shadowColor: '#000',
                                                        shadowOffset: {width: 0, height: moderateScale(.7)},
                                                        shadowOpacity: 0.6,
                                                        shadowRadius: moderateScale(2),
                                                        elevation: moderateScale(1),
                                                        // marginLeft: moderateScale(1),
                                                        // marginRight: moderateScale(1),
                                                        // marginTop: moderateScale(1),
                                                        // marginBottom: moderateScale(1),
                                                        backgroundColor: item.background_color ? item.background_color : Colors.white,
                                                    }}>
                                                    <View
                                                        style={{
                                                            width: '100%',
                                                            backgroundColor: Colors.colorSecondPrimary,
                                                            flexDirection: 'row',
                                                            padding: moderateScale(6)
                                                        }}>
                                                        <View style={{flex: .4,}}>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={item.Date}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.white,
                                                                    fontSize: moderateScale(14),


                                                                }}/>
                                                        </View>
                                                        <View style={{flex: .2, alignItems: 'center'}}>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={item.ActiveName}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.white,
                                                                    fontSize: moderateScale(14),


                                                                }}/>
                                                        </View>

                                                        <View style={{flex: .4, alignItems: 'flex-end'}}>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={item.Type}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.white,
                                                                    fontSize: moderateScale(14),


                                                                }}/>
                                                        </View>
                                                    </View>
                                                    <View style={{padding: moderateScale(6)}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.Name}
                                                            type={"bold"}
                                                            style={{
                                                                // textAlign: "center",
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(14),


                                                            }}/>
                                                        <View style={{
                                                            flexDirection: "row",
                                                          //  justifyContent: 'space-between'
                                                        }}>
                                                            <View
                                                                style={{
                                                                    flex: .8,

                                                                    // backgroundColor:"#9a2eee"
                                                                }}>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={item.Comment}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(14),


                                                                }}/>
                                                            </View>
                                                            <TouchableOpacity
                                                                disabled={!item.ActivePrint}
                                                                onPress={() => {
                                                                    Platform.OS === "web" ? NavigationService.navigateParams("FactorServiceHistorySatiaScreen", {item: item}) : Tools.GoLink(`https://app.satia.co/print?print=true&&serial=${item.RegRef}&&token=${store.getState().reducerSplashSatiaScreen.token}`,)

                                                                }}
                                                                style={{
                                                                    flex: .2,
                                                                    alignItems: 'flex-end',
                                                                    justifyContent: 'flex-end',
                                                                    // backgroundColor:"#9a2eee"
                                                                }}>
                                                                <HMIcon
                                                                    //   type={"FontAwesome"}
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"print-outline"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(22)}, {
                                                                        color: item.ActivePrint ? Colors.green : Colors.gray
                                                                    }]}/>
                                                            </TouchableOpacity>
                                                        </View>
                                                    </View>
                                                </View>

                                        }


                                    </View>


                                }}
                                keyExtractor={(item, index) => index.toString()}
                                ListEmptyComponent={() =>
                                    null}
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={typeExport._Count - 1}
                                onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                            />
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }

                            {/*     <HMModal
                                visibleModal={this.state.visibleModal === 'Modal'}
                                hiddenModal={() => this.hiddenModal()}
                                textInput={this.state["text" + this.state.indexFilter]}
                                SearchFilterFunction={text => this.SearchFilterFunction("array", "text", text, childFilter)}
                                //textInput={this.state.mobile}
                                dataSource={this.state["dataSource" + this.state.indexFilter]}
                                // onChange={() => this.onChangeCondition(index, item)}
                                onChangeItem={this.onChange}
                            />*/}


                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem = ({item, index}) => {
        return <View/>
    }

    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            <View style={[{
                //marginVertical: moderateScale(15),
                height: moderateScale(30),
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row'
            }]}>
                {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                {
                    checkIndex ?

                        <View style={{flexDirection: 'row'}}>


                            <TouchableOpacity
                                onPress={() => {
                                    //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                    let arr = container.state.arraySelected;

                                    if (idx !== -1) {
                                        arr.splice(idx, 1)

                                        container.setState({
                                                arraySelected: arr,
                                                [`selectFilter${index}`]: {
                                                    value: item.name,
                                                    id: item.id,
                                                    type: item.type
                                                },
                                                visibleModal: '',
                                            },

                                            () => {
                                                container.getData(1)
                                            }
                                        )
                                    }
                                    // container.setState({
                                    //         [`selectFilter${index}`]: {
                                    //             value: item.name,
                                    //             id: item.id,
                                    //             type:item.type
                                    //         },
                                    //         visibleModal: '',
                                    //     },
                                    //     () => {
                                    //         let arr = this.state.arraySelected;
                                    //         this.setState({
                                    //                 arraySelected: arr
                                    //             },
                                    //             () => {
                                    //                 container.getData(1)
                                    //             }
                                    //         )
                                    //
                                    //     }
                                    // )

                                }}
                                style={{
                                    alignSelf: 'center',
                                    //  marginHorizontal:moderateScale(6)
                                }}>
                                <HMIcon name={"md-close"} style={{
                                    fontSize: moderateScale(20),
                                    color: '#f2f2f2'
                                }}/>

                            </TouchableOpacity>
                        </View>
                        :
                        null


                }
                {
                    checkIndex ?
                        <View style={{width: moderateScale(6),}}/>

                        :
                        null
                }
                <TouchableOpacity
                    onPress={() => {

                        this.setState({
                                indexFilter: index,
                                typeFilter: item.type,
                                ["dataSource" + index]: item.list
                            },
                            () => {
                                //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                this.onShow('Modal')

                            })
                    }
                    }

                    style={{alignItems: 'center', flexDirection: 'row'}}
                >

                    <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                style={{
                                    color: checkIndex ? Colors.white : Colors.gray,
                                    //marginHorizontal: moderateScale(6),
                                    fontSize: moderateScale(14),
                                    textAlign: 'center',

                                }}/>
                    <HMIcon name={"ios-arrow-down"} style={{
                        fontSize: moderateScale(11),
                        color: checkIndex ? '#f2f2f2' : Colors.gray,
                        marginHorizontal: moderateScale(2),
                        marginTop: moderateScale(3)
                    }}/>
                </TouchableOpacity>


            </View>
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashSatiaScreen.Connection) {
            this.getData(1)
        } else {
            // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListServiceHistorySatiaScreen, `?type=${this.props.typee}&city=`, TypeGetListServiceHistorySatiaScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {
        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashSatiaScreen.Connection) {
            // this.props.callService(urlListServiceHistorySatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListServiceHistorySatiaScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: '',
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }

}
